import React from 'react'
import { NavLink } from 'react-router-dom'

import { Navigation, NavigationItem } from './styled'

export default function CompetitiveIntelligenceNavigation({ landing, t }) {
    return (
        <Navigation landing={landing} aria-label={t('competitive_intelligence_navigation_label')}>
            <NavigationItem as={NavLink} to="/competitive-intelligence/research" activeClassName="active">
                {t('competitive_intelligence_nav_research')}
            </NavigationItem>
            <NavigationItem as={NavLink} to="/competitive-intelligence/market" activeClassName="active">
                {t('competitive_intelligence_nav_market')}
            </NavigationItem>
            <NavigationItem as={NavLink} to="/competitive-intelligence/assistants" activeClassName="active">
                {t('competitive_intelligence_nav_assistants')}
            </NavigationItem>
            <NavigationItem as={NavLink} exact to="/competitive-intelligence/overview" activeClassName="active">
                {t('competitive_intelligence_nav_overview')}
            </NavigationItem>
        </Navigation>
    )
}
